import {
  adaptedToLocataire,
  locataireToAdapted,
  locatairesToAdapted,
} from "../../adapter/locataireAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_LOCATAIRES = "LOAD_SUCCESS_LOCATAIRES";
export const LOAD_FAIL_LOCATAIRES = "LOAD_FAIL_LOCATAIRES";
export const SAVE_SUCCESS_LOCATAIRES = "SAVE_SUCCESS_LOCATAIRES";
export const SAVE_FAIL_LOCATAIRES = "SAVE_FAIL_LOCATAIRES";
export const UPDATE_SUCCESS_LOCATAIRES = "UPDATE_SUCCESS_LOCATAIRES";
export const UPDATE_FAIL_LOCATAIRES = "UPDATE_FAIL_LOCATAIRES";
export const DELETE_SUCCESS_LOCATAIRES = "DELETE_SUCCESS_LOCATAIRES";
export const DELETE_FAIL_LOCATAIRES = "DELETE_FAIL_LOCATAIRES";

export function loadLocataires() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesLocataires`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.locataire);
          dispatch({
            type: LOAD_SUCCESS_LOCATAIRES,
            payload: locatairesToAdapted(res.locataire),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_LOCATAIRES,
            error: err,
          });
        });
    });
  };
}

export function saveLocataire(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesLocataires`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToLocataire(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(locataireToAdapted(res.locataire));
          dispatch({
            type: SAVE_SUCCESS_LOCATAIRES,
            payload: locataireToAdapted(res.locataire),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_LOCATAIRES,
            error: err,
          })
        );
    });
  };
}

export function updateLocataire(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesLocataires/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToLocataire(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(locataireToAdapted(res.locataire));
          dispatch({
            type: UPDATE_SUCCESS_LOCATAIRES,
            payload: locataireToAdapted(res.locataire),
            id: id,
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_LOCATAIRES,
            error: err,
          })
        );
    });
  };
}

export function archiveLocataire(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesLocataires/archive/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, params)
        .then((res) => res.json())
        .then((res) => {
          resolve(res.locataire);
          dispatch({
            type: UPDATE_SUCCESS_LOCATAIRES,
            payload: locataireToAdapted(res.locataire),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_LOCATAIRES,
            error: err,
          })
        );
    });
  };
}

export function deleteLocataire(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesLocataires/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.locataire);
          dispatch({
            type: DELETE_SUCCESS_LOCATAIRES,
            payload: locataireToAdapted(res.locataire),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_LOCATAIRES,
            error: err,
          });
        });
    });
  };
}
